export type InlineCommunicationEntryState = "date_published" | "agenda_published" | "protocol_published" | "closed";
export type InlineAssemblyState =
    | "preparing"
    | "active"
    | "agenda_published"
    | "date_published"
    | "protocol_published"
    | "closed";

export const inlineCommunicationProgressSteps = [
    {
        state: "date_published",
        labelKey: "date_published"
    },
    {
        state: "agenda_published",
        labelKey: "agenda_published"
    },
    {
        state: "protocol_published",
        labelKey: "protocol_published"
    },
    {
        state: "closed",
        labelKey: "closed"
    }
] as const;

export const getInlineCommunicationProgressSteps = (
    currentAssemblyState: InlineAssemblyState | undefined,
    activeEntryState: InlineCommunicationEntryState
) => {
    return inlineCommunicationProgressSteps.map((step, index) => {
        const isCompleted = getIsInlineCommunicationStepCompleted(currentAssemblyState, step.state);
        const isCurrent =
            !isCompleted &&
            (step.state === activeEntryState ||
                (currentAssemblyState === "preparing" && step.state === "date_published"));

        return {
            ...step,
            index: index + 1,
            isCompleted,
            className: isCompleted
                ? "ProgressStepCompleted"
                : isCurrent
                  ? "ProgressStepCurrent"
                  : "ProgressStepPending"
        };
    });
};

export const getIsInlineCommunicationConnectorFilled = (
    currentStepState: InlineCommunicationEntryState,
    nextStepState: InlineCommunicationEntryState,
    activeEntryState: InlineCommunicationEntryState,
    currentAssemblyState: InlineAssemblyState | undefined
) => {
    return (
        getIsInlineCommunicationStepCompleted(currentAssemblyState, currentStepState) || nextStepState === activeEntryState
    );
};

export const getIsInlineCommunicationStepCompleted = (
    currentAssemblyState: InlineAssemblyState | undefined,
    stepState: InlineCommunicationEntryState
) => {
    switch (currentAssemblyState) {
        case "date_published":
            return stepState === "date_published";
        case "agenda_published":
            return stepState === "date_published" || stepState === "agenda_published";
        case "protocol_published":
            return stepState !== "closed";
        case "closed":
            return true;
        default:
            return false;
    }
};
